'use client';

import React from 'react';
import RateResortSearch from '@/components/common/RateResortSearch/RateResortSearch';

export const TEMPLATE_ID = '4.2';
export const TEMPLATE_NAME = 'Rate A Resort Page';

export default function RateResortPage() {
  return (
    <>
      <RateResortSearch regionTitle="Michigan" isWidget />
    </>
  );
}

// fetchProps moved to ./rate-resort.server.ts so the App Router RSC page can
// import the data fetcher without pulling in this 'use client' bundle.
